module.exports = __webpack_public_path__ + "static/media/howls.80da1e86.jpg";